import { render, staticRenderFns } from "./IvHealModal.vue?vue&type=template&id=f618ab2a&"
import script from "./IvHealModal.vue?vue&type=script&lang=ts&"
export * from "./IvHealModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports